// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"b-","newscontentBox":"b-"};